import React from 'react';

import PayoffChart from 'screens/OptionsProfitCalculatorStrategy/Chart';

interface OpcChartProps {
  payoffGraph: any;
  maxProfitLoss: any;
  breakEvenPoints: any;
  probabilityData: any;
  spot: any;
}

export const OpcChart: React.FC<OpcChartProps> = ({
  payoffGraph,
  maxProfitLoss,
  breakEvenPoints,
  probabilityData,
  spot,
}) => {
  return (
    <div className="mt-4">
      <PayoffChart
        data={payoffGraph}
        breakEvenPoints={breakEvenPoints || []}
        activeItem="profit"
        currentStockPrice={spot}
        xMin={spot * 0.9}
        xMax={spot * 1.1}
        maxLoss={maxProfitLoss?.maxLoss || 0}
        probabilityData={probabilityData}
        animated={false}
      />
    </div>
  );
};

export default OpcChart;
